import { computed, inject, Injectable } from '@angular/core';

import {
    EntitiesTableByLayerService,
    EntitiesTableTypeEnum,
} from '@connect-services/client/services/entities-table-by-layer.service';
import { GeographicFilterService } from '@connect-services/client/services/geographic-filter.service';
import { SelectZoneLayerService } from '@connect-services/client/services/select-zone-layer.service';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionChangeSelectionService {
    public readonly isActive = computed(() => this.entitiesTableByLayerService.isFieldInterventionSelectionActive());

    private readonly entitiesTableByLayerService = inject(EntitiesTableByLayerService);
    private readonly geographicFilterService = inject(GeographicFilterService);
    private readonly selectZoneLayerService = inject(SelectZoneLayerService);

    public reset(): void {
        this.entitiesTableByLayerService.isFieldInterventionSelectionActive.set(false);

        this.entitiesTableByLayerService.resetData();
        this.selectZoneLayerService.resetState();

        this.geographicFilterService.isSelectZoneActive.set(false);
    }

    public startFieldInterventionSelection(): void {
        this.entitiesTableByLayerService.isFieldInterventionSelectionActive.set(true);
        this.entitiesTableByLayerService.tableType.set(EntitiesTableTypeEnum.FILTERED_TABLE);
    }

    public stopFieldInterventionSelection(): void {
        this.entitiesTableByLayerService.isFieldInterventionSelectionActive.set(false);
    }
}
